import { FormLabel, type FormLabelProps } from '@mui/material';

type RaLabelProps = {
  label: React.ReactNode;
} & Omit<FormLabelProps, 'children'>;

export const RaLabel: React.FC<RaLabelProps> = ({
  label,
  required,
  ...labelProps
}) => {
  const { sx: customSx, ...rest } = labelProps;
  return (
    <FormLabel
      {...rest}
      sx={[
        {
          mb: 0.75,
          fontSize: '0.8125rem',
          fontWeight: 500,
          color: 'text.secondary',
          letterSpacing: '0.01em',
          '&.Mui-focused': { color: 'text.secondary' },
          '& .MuiFormLabel-asterisk': { color: 'error.main' },
        },
        ...(Array.isArray(customSx) ? customSx : customSx ? [customSx] : []),
      ]}
      required={required}
    >
      {label}
    </FormLabel>
  );
};
